<mat-toolbar class="app-footer" role="contentinfo">
    <mat-toolbar-row class="footer-row footer-row-top">
        <span class="footer-center-text">
            Copyright © {{ year }} Honeywell International Inc.
        </span>
    </mat-toolbar-row>

    <mat-toolbar-row class="footer-row footer-row-bottom">
        <span class="footer-version">
            Version {{ versionNum }}
        </span>

        <span class="footer-user-id" *ngIf="userService?.dbBBCSId" matTooltip="BBCSUserId">
            {{ userService.dbBBCSId }}
        </span>
    </mat-toolbar-row>
</mat-toolbar>